import { useEffect, useState } from 'react';
import axiosInstance from '../../utils/axios/axiosInstance';

const NoticeDetails = ({ notice, onClose }) => {
  const [downloads, setDownloads] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDownloads = async () => {
      if (!notice?.id) return;
      setLoading(true);
      setError(null);
      try {
        const { data } = await axiosInstance.get('/notices/download-prepared-files', {
          params: { notice_id: notice.id }
        });
        setDownloads(data?.data || {});
      } catch (err) {
        setError(err?.response?.data?.message || 'Failed to load files');
      } finally {
        setLoading(false);
      }
    };
    loadDownloads();
  }, [notice?.id]);

  const formatDate = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
  };

  if (!notice) return null;

  return (
    <>
      <div className="modal fade show d-block" style={{ zIndex: 9999 }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: '1000px' }}>
          <div className="modal-content">

            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Notice  – {notice.notice_type}</h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} />
            </div>

            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {error && <div className="alert alert-danger">{error}</div>}
              {loading && <div className="text-muted">Loading files…</div>}

              <div className="row g-3">
                <div className="col-md-6">
                  <div className="card h-100">
                    <div className="card-header bg-light"><strong>Summary</strong></div>
                    <div className="card-body">
                      <p className="mb-1 border-bottom"><strong>Type:</strong> {notice.notice_type}</p>
                      <p className="mb-1 border-bottom"><strong>Status:</strong> <span className="badge bg-info text-dark">{notice.status}</span></p>
                      <p className="mb-1 border-bottom"><strong>Province:</strong> {notice.province_code || '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Reason:</strong> {notice.notice_reason || '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Termination:</strong> {formatDate(notice.termination_date)}</p>
                      <p className="mb-1 border-bottom"><strong>Total Rent Owing:</strong> {notice.total_rent_owing ? `$${Number(notice.total_rent_owing).toFixed(2)}` : '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Issued:</strong> {formatDate(notice.createdAt)}</p>
                      <p className="mb-1 border-bottom"><strong>Updated:</strong> {formatDate(notice.updatedAt)}</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card h-100">
                    <div className="card-header bg-light"><strong>People</strong></div>
                    <div className="card-body">
                      <p className="mb-1 "><strong>Tenant:</strong> {notice.tenant ? `${notice.tenant.first_name} ${notice.tenant.last_name}` : '-'}</p>
                      <p className="mb-1 text-muted border-bottom">{notice.tenant?.email || ''}</p>
                      <p className="mb-1 "><strong>Landlord:</strong> {notice.landlord ? `${notice.landlord.first_name} ${notice.landlord.last_name}` : '-'}</p>
                      <p className="mb-1 text-muted border-bottom">{notice.landlord?.email || ''}</p>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-header bg-light"><strong>Lease & Property</strong></div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <p className="mb-1 border-bottom"><strong>Lease:</strong> {notice.lease?.lease_name || '-'}</p>
                          <p className="mb-1 border-bottom"><strong>Active Notice:</strong> {notice.lease?.active_notice || '-'}</p>
                          <p className="mb-1 border-bottom"><strong>Notice Deadline:</strong> {formatDate(notice.lease?.notice_deadline)}</p>
                        </div>
                        <div className="col-md-5">
                          <p className="mb-1 border-bottom"><strong>Property:</strong> {notice.lease?.property?.property_name || '-'}</p>
                          <p className="mb-1 border-bottom"><strong>Address:</strong> {notice.lease?.property ? `${notice.lease.property.street_number || ''} ${notice.lease.property.street_name || ''}, ${notice.lease.property.city || ''}` : '-'}</p>
                          <p className="mb-1 border-bottom"><strong>Province:</strong> {notice.lease?.property?.province?.name || '-'}</p>
                        </div>
                        <div className="col-md-3">
                          <p className="mb-1 border-bottom"><strong>Unit:</strong> {notice.lease?.unit?.unit || '-'}</p>
                          <p className="mb-1 border-bottom"><strong>Next Payment:</strong> {formatDate(notice.lease?.next_payment_date)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-header bg-light"><strong>Files</strong></div>
                    <div className="card-body d-flex flex-wrap gap-2">
                      {downloads && (
                        <>
                          {downloads.notice_pdf_url && <a className="btn btn-sm btn-outline-primary" href={downloads.notice_pdf_url} target="_blank" rel="noreferrer">Notice PDF</a>}
                          {downloads.pdf_url && <a className="btn btn-sm btn-outline-primary" href={downloads.pdf_url} target="_blank" rel="noreferrer">Lease PDF</a>}
                          {downloads.service_pdf_url && <a className="btn btn-sm btn-outline-primary" href={downloads.service_pdf_url} target="_blank" rel="noreferrer">Service PDF</a>}
                          {downloads.application_pdf_url && <a className="btn btn-sm btn-outline-primary" href={downloads.application_pdf_url} target="_blank" rel="noreferrer">Application PDF</a>}
                          {downloads.ledger_pdf_url && <a className="btn btn-sm btn-outline-primary" href={downloads.ledger_pdf_url} target="_blank" rel="noreferrer">Ledger PDF</a>}
                          {!downloads.notice_pdf_url && !downloads.pdf_url && !downloads.service_pdf_url && !downloads.application_pdf_url && !downloads.ledger_pdf_url && (
                            <span className="text-muted">No files available.</span>
                          )}
                        </>
                      )}
                      {!downloads && !loading && <span className="text-muted">No files loaded.</span>}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>Close</button>
            </div>

          </div>
        </div>
      </div>
      {/* <div className="modal-backdrop fade show" onClick={onClose} /> */}
         {/* BACKDROP */}
      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default NoticeDetails;
